import { cityLocalDate } from "@finda/shared/genres";

// Match the production host that serves pages without a redirect.
export const SITE_URL = "https://www.finda.show";

export function localizedPath(path: string, locale: string): string {
  return locale === "en" ? path : `/${locale}${path === "/" ? "" : path}`;
}

export function pageAlternates(path: string, locale: string, indexable = true) {
  return {
    canonical: localizedPath(path, locale),
    languages: indexable ? { en: path, "de-CH": localizedPath(path, "de-CH") } : undefined,
  };
}

// A date-only string parsed as a Date becomes UTC midnight. Comparing it to
// the current instant incorrectly noindexes every show on its performance day.
export function isPastLocalDate(date: string | null, timezone: string, now = new Date()): boolean {
  return date !== null && date < cityLocalDate(timezone, now);
}
